import { Gift } from 'lucide-react';
import { Toggle } from '../../ui/index.js';
import './crm-form-fields.css';

export function GiftCardField({
  checked,
  disabled,
  onCheckedChange,
}: {
  checked?: boolean;
  disabled?: boolean;
  onCheckedChange?(checked: boolean): void;
}) {
  return (
    <div className="crm-gift-card-field">
      <Gift size={20} aria-hidden="true" />
      <Toggle
        label="Gift card"
        checked={checked}
        disabled={disabled}
        onCheckedChange={onCheckedChange}
      />
    </div>
  );
}
